'use client'

import React, { useEffect } from 'react'
import { CartProvider } from '@/components/cart/CartProvider'
import CartSidebar from '@/components/cart/CartSidebar'
import { useCartStore } from '@/stores/cartStore'
import { ThemeProvider } from 'next-themes'
import { Toaster } from '@/components/ui/toaster'
import { useSiteSettings } from '@/app/[locale]/utils/site-settings-client'


export default function ClientProviders({ children }: { children: React.ReactNode }) {
  
  // Manually rehydrate the cart store on mount to avoid SSR/client mismatch.
  useEffect(() => {
    useCartStore.persist.rehydrate()
  }, [])

  const { settings } = useSiteSettings()
  const isB2B = !!settings.is_b2b


  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <CartProvider>
        {children}
        <Toaster />
        <CartSidebar isB2B={isB2B} />
        
      </CartProvider>
    </ThemeProvider>
  )
}